<template>
    <div class="modal-dialog modal-lg" v-if="showModal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">{{ form.id > 0 ? 'Editar Patrón' : 'Registrar Patrón' }}</h4>
                <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form">
                    <div class="row">
                        <div class="col-sm-4" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>RFC</label>
                                <input class="form-control" type="text" v-model="form.rfc" v-bind:class="formSubmitted ? errors.rfc ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.rfc = form.rfc.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.rfc">{{ errors.rfc }}</div>
                            </div>
                        </div>
                        <div class="col-sm-8" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>Nombre</label>
                                <input class="form-control" type="text" v-model="form.name" v-bind:class="formSubmitted ? errors.name ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.name = form.name.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>Registro Patronal</label>
                                <input class="form-control" type="text" v-model="form.registro_patronal" v-bind:class="formSubmitted ? errors.registro_patronal ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.registro_patronal = form.registro_patronal.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.registro_patronal">{{ errors.registro_patronal }}</div>
                            </div>
                        </div>
                        <div class="col-sm-6" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>Código Postal</label>
                                <input class="form-control" type="text" v-model="form.zipcode" v-bind:class="formSubmitted ? errors.zipcode ? 'is-invalid' : 'is-valid' : ''" placeholder="">
                                <div class="invalid-feedback" v-if="errors.zipcode">{{ errors.zipcode }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="storeEmployerValidation">{{ form.id > 0 ? 'Guardar' : 'Registrar' }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employers'

import validations from "@/mixins/validations/employerValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

export default {
    name: 'employer_modal',
    mixins: [validations, modalCleanupMixin],
    components: {
        
    },
    data(){
        return{
            showModal: true,
            job_positions: [],
        }
    },
    methods: {
        setEmployer(data){
            this.setForm(data);

            this.showModal = true;
        },
        async storeEmployer(form) {
            let response = false;

            if(form.id > 0){
                response = await ws.updateEmployer(form);
            }
            else{
                response = await ws.storeEmployer(form.rfc, form.name);
            }
            
            if(response.type == "success"){
                this.$toast.success(response.message);
                
                this.showModal = false;
            
                this.closeModal();

                if(form.id > 0){
                    this.$emit("update", response.data );
                }
                else{
                    this.$emit("store", response.data );
                }
            }
            else{
                this.$toast.error(response.message);
            }
        },
    }
}
</script>